"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7840],{

/***/ 97840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51071);



var farms = [
    /**
   * These 3 farms (PID 0, 1, 2) should always be at the top of the file.
   */ {
        pid: 0,
        lpSymbol: "CANDY",
        lpAddress: "0x54E53ed24C12c1d3Df7D653587E2f27d3FbaE3d2",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.candy */ .UB.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.wmatic */ .UB.wmatic
    },
    {
        pid: 1,
        lpSymbol: "CANDY-MATIC LP",
        lpAddress: "0xA67FE0Cb496A4a397728DB432fE0E210a5C68BB9",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.candy */ .UB.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.wmatic */ .UB.wmatic
    },
    {
        pid: 2,
        lpSymbol: "CANDY-USDT LP",
        lpAddress: "0x75061F73B81652c7940545d7824fe2E74CEB63C8",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.candy */ .UB.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.usdt */ .UB.usdt
    },
    {
        pid: 3,
        lpSymbol: "CANDY-USDC LP",
        lpAddress: "0x26fEa198cE848499Bba6eeb0a4b97561009E96A0",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.candy */ .UB.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .polygonTokens.usdc */ .UB.usdc
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .serializeToken */ .Mq)(p.token),
        quoteToken: (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .serializeToken */ .Mq)(p.quoteToken)
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);